import React from 'react'
import { Button } from '@telavita-core/react-design-kit'
import FirstEnterprisePlanImg from 'static/svg/prescription-delivery-disclaimer.svg'
import ModalGeneric from '../ModalGeneric'
import * as S from './styles'
import { PrescriptionDeliveryInformationCard } from 'components/PrescriptionDeliveryInformationCard'

type PrescriptionDeliveryInformationModalProps = {
  onSuccess: () => void;
  onClose: () => void;
};

export function PrescriptionDeliveryInformationModal({
  onSuccess,
  onClose,
}: PrescriptionDeliveryInformationModalProps): JSX.Element {
  return (
    <ModalGeneric modalTitle="" hasCloseButton hasTopBarActive={false}>
      <S.Container>
        <img
          src={FirstEnterprisePlanImg}
          alt="Ícone de scooter entre um documento e um marcador de localização."
        />
        <PrescriptionDeliveryInformationCard />
        <S.ButtonsWrapper>
          <Button variant="contained" uppercase={false} onClick={onSuccess}>
            Prosseguir com o agendamento
          </Button>
          <Button variant="outlined" uppercase={false} onClick={onClose}>
            Voltar
          </Button>
        </S.ButtonsWrapper>
      </S.Container>
    </ModalGeneric>
  )
}
